require('jquery-validation');

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ValidationHelpers = require('./validate-helpers');

var FORMS      = '.js-formValidateSubmitNative';

module.exports = function() {

    $(FORMS).each(function(){

        /*
         * Initialize the jQuery Validator
         */
        $(this).validate({
            submitHandler: function(form) {
                ValidationHelpers.setLoading( $(form), true);
                ValidationHelpers.doNativeSubmit(form);
            }
        });

        /*
         * This helper method prepares messages for the validator.
         * It MUST be loaded after the validator is loaded.
         */
        ValidationHelpers.loadFormMessages( $(this) );

    });

};
